var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("i", {
    staticClass: "fa fa-chevron-down",
    class: { flip: !_vm.down }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }